export default __webpack_public_path__ + "static/media/Sakshi.c7471c66.jpg";